<template>
  <div class="defect-severity">
    <div>
      <div class="title">{{ $l("title_category_tree") || "产品疵点分类" }}</div>
      <div
        class="category-tree"
        :style="`height: ${requirementsHeight - 50}px;`"
      >
        <CategoryTree
          :dfDefinitionCode="dfDefinitionCode"
          :disabled="disabled"
          @chooseNode="chooseNode"
        ></CategoryTree>
      </div>
    </div>
    <div class="defect-severity-table" ref="defectSeverityTable">
      <DefectSeverityTable
        :dfDefinitionCode="dfDefinitionCode"
        :dfDefinitionCategoryCode="dfDefinitionCategoryCode"
        :disabled="disabled"
        ref="defectSeverityTable"
      ></DefectSeverityTable>
    </div>
  </div>
</template>
<script>
import CategoryTree from "./category-tree";
import DefectSeverityTable from "./defect-severity-table";
export default {
  props: {
    dfDefinitionCode: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      resizeObserver: "",
      dfDefinitionCategoryCode: "",
      requirementsHeight: 0,
    };
  },
  components: { CategoryTree, DefectSeverityTable },
  methods: {
    chooseNode({ dfDefinitionCategoryCode }) {
      this.dfDefinitionCategoryCode = dfDefinitionCategoryCode;
    },
  },
  mounted() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this.requirementsHeight = entry.target.clientHeight;
        console.log(entry.target.clientHeight);
      }
    });
    this.resizeObserver.observe(this.$refs.defectSeverityTable);
  },
  beforeDestroy() {
    if (this.resizeObserver && this.$refs.defectSeverityTable) {
      this.resizeObserver.unobserve(this.$refs.defectSeverityTable);
      this.resizeObserver.disconnect(); // 彻底断开观察器
    }
  },
};
</script>
<style lang="scss" scoped>
.defect-severity {
  display: flex;
  .defect-severity-table {
    display: flex;
    flex: 1;
    margin-left: 25px;
  }
}
.category-tree {
  width: 280px;
  overflow: auto;
  padding: 20px 0;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #071437;
}
</style>
